export default __webpack_public_path__ + "static/media/vi_share_fi-connect_au.0b719490.svg";